const collectMockSchemas = (): string[] => {
  if (process.env.REACT_APP_FEATURE_MOCKS_ENABLED !== 'true') {
    return [];
  }

  const context = import.meta.webpackContext('mocks/schemas', {
    recursive: true,
    regExp: /\.graphql$/,
  });

  return context
    .keys()
    .filter(key => !key.includes('_template'))
    .map(key => {
      const module_: unknown = context(key);

      if (typeof module_ === 'string') {
        return module_;
      }

      if (typeof module_ === 'object' && module_ !== null && 'default' in module_) {
        return String(module_.default);
      }

      return '';
    });
};

export const mockSchemaStrings: string[] = collectMockSchemas();
